import { render } from "./CreatePostModal.vue?vue&type=template&id=36571c5a&scoped=true"
import script from "./CreatePostModal.vue?vue&type=script&lang=js"
export * from "./CreatePostModal.vue?vue&type=script&lang=js"

import "./CreatePostModal.vue?vue&type=style&index=0&id=36571c5a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36571c5a"]])

export default __exports__